import { graphql } from "@/lib/gql/__generated__/gql";

export const PAYMENT_DEPOSIT_ACCOUNT_QUERY = graphql(/* GraphQL */ `
	query PaymentDepositAccountQuery($hotelID: ID!) {
		paymentDepositAccount(hotelID: $hotelID) {
			bankAccountHolderName
			bankAccountNumber
			bankAccountType
			bankBranchCode
			bankCode
			hotelID
			minimumTransferAmount
			id
		}
	}
`);
